import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { FilterCompleteService, IFilterComplete } from '../../../filter-complete/filter-complete';
import { ReservationService } from '../../../services/reservation.service';
import { PatientSearch } from '../../../model/patient/patient-search';
import { Data } from '@angular/router';
import { IFilterComponent, SearchFilter } from '../../../infrastructure/iFilter-component';
import { FilterService } from '../../../services/filter.service';
import { ServiceFilter } from '../../../model/service-filter';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { PracticeRegionFilter } from '../../../model/practice-region-filter';
import { CenterFilter } from '../../../model/center-filter';
import { EquipmentFilter } from '../../../model/equipment-filter';
import { FilterRecordService } from '../../../services/filter-record.service';
import { ReportViewerDialogComponent } from '../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-reservation-filter-component',
  templateUrl: './reservation-filter.component.html',
  styleUrls: ['./reservation-filter.component.css']
})

export class ReservationFilterComponent implements IFilterComponent, OnInit {

  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  filterCompleteEquipments: FilterCompleteService<EquipmentFilter>;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private dialog: MatDialog
    , private filterRecordService: FilterRecordService
    , private reservationService: ReservationService) {

    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Patient: [null],
      Physician: [''],
      Service: [''],
      Center: [''],
      Equipment: [''],
      PracticeRegion: [''],
      Over: [true],
      Cancel: [false],
      Atended: [false],
      OrderByPatient: [ false ]
    });

    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>([], this.form.controls.Equipment);
    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>([], this.form.controls.Center);
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>([], this.form.controls.Physician);
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>([], this.form.controls.Service);
    this.filterCompletePracticesRegion = new FilterCompleteService<PracticeRegionFilter>([], this.form.controls.PracticeRegion);

  }

  get filteredEquipmentsOptions() { return this.filterCompleteEquipments ? this.filterCompleteEquipments.filteredOptions : []; }
  get filteredCentersOptions() { return this.filterCompleteCenters ? this.filterCompleteCenters.filteredOptions : []; }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion ? this.filterCompletePracticesRegion.filteredOptions : []; }
  get filteredPhysiciansOptions() { return this.filterCompletePhysicians ? this.filterCompletePhysicians.filteredOptions : []; }
  get filteredServicesOptions() { return this.filterCompleteServices ? this.filterCompleteServices.filteredOptions : []; }
  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('DateFrom');
    requiredTags.push('DateTo');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  saveFilters(): void {
    this.filterRecordService.saveFilters('ReservationFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('ReservationFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.reservationService.getReservationSearchItems(
        <boolean>(this.form.controls.Over.value ?  this.form.controls.Over.value : false)
      , <boolean>(this.form.controls.Cancel.value ?  this.form.controls.Cancel.value : false)
      , <boolean>(this.form.controls.Atended.value ?  this.form.controls.Atended.value : false)
      , <boolean>(this.form.controls.OrderByPatient.value ?  this.form.controls.OrderByPatient.value : false)
      , <Date>this.form.controls.DateFrom.value
      , <Date>this.form.controls.DateTo.value
      , (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null)
      , (this.form.controls.Equipment.value ? (<EquipmentFilter>this.form.controls.Equipment.value).Id : null)
      , (this.form.controls.Service.value ? (<ServiceFilter>this.form.controls.Service.value).Id : null)
      , (this.form.controls.Physician.value ? (<PhysicianFilter>this.form.controls.Physician.value).Id : null)
      , (this.form.controls.PracticeRegion.value ? (<PracticeRegionFilter>this.form.controls.PracticeRegion.value).Id : null)
      , null
      , null
      , (this.form.controls.Center.value ? (<CenterFilter>this.form.controls.Center.value).Id : null));
  }

  async showReport() {

     const reportViewer = await this.reservationService.getReservationReport(
        <boolean>(this.form.controls.Over.value ?  this.form.controls.Over.value : false)
      , <boolean>(this.form.controls.Cancel.value ?  this.form.controls.Cancel.value : false)
      , <boolean>(this.form.controls.Atended.value ?  this.form.controls.Atended.value : false)
      , <Date>this.form.controls.DateFrom.value
      , <Date>this.form.controls.DateTo.value
      , (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null)
      , (this.form.controls.Equipment.value ? (<EquipmentFilter>this.form.controls.Equipment.value).Id : null)
      , (this.form.controls.Service.value ? (<ServiceFilter>this.form.controls.Service.value).Id : null)
      , (this.form.controls.Physician.value ? (<PhysicianFilter>this.form.controls.Physician.value).Id : null)
      , (this.form.controls.PracticeRegion.value ? (<PracticeRegionFilter>this.form.controls.PracticeRegion.value).Id : null)
      , null
      , null
      , (this.form.controls.Center.value ? (<CenterFilter>this.form.controls.Center.value).Id : null));

      this.dialog.open(ReportViewerDialogComponent, {
        width: '90%',
        height: '600px',
        data: reportViewer
      });
  }

  async ngOnInit() {
    this.filterCompleteCenters =
    new FilterCompleteService<CenterFilter>((await this.filterService.getCentersFilter()), this.form.controls.Center);
    this.filterCompleteServices =
    new FilterCompleteService<ServiceFilter>((await this.filterService.getServicesFilter()), this.form.controls.Service);
    this.filterCompletePhysicians =
    new FilterCompleteService<PhysicianFilter>((await this.filterService.getPhysiciansFilter()), this.form.controls.Physician);
    this.filterCompletePracticesRegion =
    new FilterCompleteService<PracticeRegionFilter>(
      (await this.filterService.getPracticesRegionFilter()), this.form.controls.PracticeRegion);
    this.filterCompleteEquipments =
     new FilterCompleteService<EquipmentFilter>((await this.filterService.getEquipmentsFilter()), this.form.controls.Equipment);
  }
}
